//https://www.npmjs.com/package/smooth-scroll

import SmoothScroll from "smooth-scroll";

new SmoothScroll('a[href*="#"]', {
  ignore:
    "[data-vc-container], #tab-title-description a, #tab-title-additional_information a, #tab-title-accessories a, .qty-btn.btn-plus, .qty-btn.btn-minus"
});
